import { SheetData } from '../../types'
import { anomalyDescriptions, standardColumns, codingAnomalies } from '../../constants'
import { sumBy, camelCase, flatten, uniqBy } from 'lodash'
import { ConfigSection } from '../../../../shared/types'
import { getAnomalyDataSections } from '../../utils/anomalies'

export default function formatAnomalyForExport(
  anomaly: any,
  reportEndDate: string,
  configSections?: ConfigSection[],
): SheetData | null {
  const dataSections = getAnomalyDataSections({
    anomaly,
    context: 'export',
    configSections,
    reportEndDate,
  })

  if (!dataSections?.length) {
    return null
  }

  const withHeaders = dataSections.map((dataSection) => ({
    ...dataSection,
    columns: standardColumns,
  }))

  const key = camelCase(anomaly.anomalyName)

  let transactionCount = sumBy(dataSections, (dataSection) => dataSection.data!.length)

  // for export data, coding anomaly data is already a flat list of transaction line items. We just have to count them by transactionId
  if (codingAnomalies.includes(key)) {
    const flatTxns = flatten(dataSections.map((dataSection) => dataSection.data))

    transactionCount = uniqBy(flatTxns, 'transactionId').length
  }

  const titleData = {
    'Anomaly Name': anomaly.anomalyName,
    'Anomaly Type': anomaly.anomalyType,
    Transactions: transactionCount,
    Description: anomalyDescriptions[key],
  }

  return {
    sheetName: anomaly.anomalyName,
    titleSection: { titleData },
    dataSections: withHeaders,
  }
}
